import React from 'react'
import PropTypes from 'prop-types'
import PapiUser from '../user/PapiUser'
import PapiGroup from '../group/PapiGroup'
import PapiApplication from '../application/PapiApplication'
import PapiEntitlement from '../entitlement/PapiEntitlement'

const PapiEntity = ({entity, showLink}) => {
    if (entity) {
        switch (entity.type) {
            case 'user':
                return <PapiUser user={entity} showLink={showLink} />
            case 'group':
                return <PapiGroup group={entity} showLink={showLink} />
            case 'application':
                return <PapiApplication application={entity} showLink={showLink} />
            case 'entitlement':
                return <PapiEntitlement entitlement={entity} showLink={showLink} />
            default:
                return null
        }
    }
    return null
}

PapiEntity.propTypes = {
    entity: PropTypes.shape({
        type: PropTypes.oneOf(['user', 'group', 'application', 'emtitlement']),
        name: PropTypes.string.isRequired,
        id: PropTypes.string.isRequired
    }).isRequired,
    showLink: PropTypes.bool
}

export default PapiEntity
